import React, {Component, Fragment} from 'react'
import { connect } from 'react-redux'
import autobind from 'autobind-decorator'
import CodeMirrorComponent from "react-codemirror-component";
import 'codemirror/addon/fold/xml-fold'
import 'codemirror/addon/edit/matchtags'
import 'codemirror/addon/edit/matchbrackets'
import 'codemirror/addon/edit/closebrackets'
import 'codemirror/addon/edit/closetag'
import 'codemirror/mode/xml/xml'
import 'codemirror/mode/javascript/javascript'
import 'codemirror/mode/css/css'
import 'codemirror/mode/htmlmixed/htmlmixed'
import 'codemirror/lib/codemirror.css'
import {changeContent, changeTitle} from "../../../actions/post";
import CategorySelect from "../CategorySelect";
import SimpleEditorToolbar from "../SimpleEditorToolbar";
import CodeMirrorTistory from "../../../lib/codemirror/CodeMirrorTistory";
import PostTitle from "../PostTitle";

@connect(state => ({
  post: state.post.newPost,
  blog: state.blog
}), dispatch => ({
  handleChangeContent: (content) => {
    dispatch(changeContent(content))
  }
}))
class HtmlEditor extends Component {
  constructor(props) {
    super(props);
    this.codemirrorComponent = React.createRef();
  }

  componentDidMount() {
    window.activeEditor = this.codemirrorComponent.current.getCodeMirror();
  }

  shouldComponentUpdate(nextProps, nextState, nextContext) {
    if (Math.abs(this.props.post.content.length - nextProps.post.content.length) > 100) {
      this.codemirrorComponent.current.getCodeMirror().refresh();
    }
    return false;
  }

  @autobind
  handleChangeContent(content) {
    const { handleChangeContent } = this.props;
    handleChangeContent(content);
  }

  @autobind
  handleAttachImage(data) {
    CodeMirrorTistory.insertImage(this.codemirrorComponent.current.getCodeMirror(), data)
  }

  @autobind
  handleAttachFile(data) {
    CodeMirrorTistory.insertFile(this.codemirrorComponent.current.getCodeMirror(), data)
  }

  render() {
    const { post } = this.props;
    return (
      <div className={'html-editor'}>

        <CategorySelect />
        <PostTitle/>

        <SimpleEditorToolbar
          onAttachImage={this.handleAttachImage}
          onAttachFile={this.handleAttachFile}
        />

        <div className={'mce-edit-area'}>
          <CodeMirrorComponent
            ref={this.codemirrorComponent}
            autoFocus={true}
            value={post.content}
            onChange={this.handleChangeContent}
            options={{
              lineWrapping: true,
              lineNumbers: true,
              mode: 'htmlmixed',
              theme: 'tistory-html',
              htmlMode: true,
              matchClosing: true
            }}
          />
        </div>
      </div>
    )
  }
}

export default HtmlEditor
